import { render, staticRenderFns } from "./PrecoDinamicoForm.vue?vue&type=template&id=fb0cf556&scoped=true"
import script from "./PrecoDinamicoForm.vue?vue&type=script&lang=js"
export * from "./PrecoDinamicoForm.vue?vue&type=script&lang=js"
import style0 from "./PrecoDinamicoForm.vue?vue&type=style&index=0&id=fb0cf556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0cf556",
  null
  
)

export default component.exports